<template>
  <div>
    <v-layout wrap>
      <v-flex >
        <v-form ref="viewPresentForm">
          <v-card-text>
            <v-layout wrap>
              <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
                <v-text-field
                    type="text"
                    :label="$t('Tên tài khoản')"
                    v-model.trim="item.userName"
                    name="userName"
                    v-validate="'required'"
                    maxLength="500"
                    :disabled="true"
                    :error-messages="errors.first('userName')"
                    :data-vv-as="$t('userName')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
                <v-text-field
                    type="text"
                    :label="$t('Tên trường')"
                    v-model.trim="item.fullName"
                    name="fullName"
                    v-validate="'required'"
                    maxLength="500"
                    :error-messages="errors.first('fullName')"
                    :data-vv-as="$t('fullName')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
                <v-text-field
                    type="text"
                    :label="$t('Số điện thoại')"
                    v-model.trim="item.phone"
                    name="phone"
                    v-validate="'required'"
                    maxLength="500"
                    :error-messages="errors.first('phone')"
                    :data-vv-as="$t('phone')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
                <v-text-field
                    type="text"
                    :label="$t('Email')"
                    v-model.trim="item.email"
                    name="email"
                    v-validate="'required'"
                    maxLength="500"
                    :error-messages="errors.first('email')"
                    :data-vv-as="$t('email')"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-form>
        <div style="text-align: right">
          <v-btn color="primary" @click="onSave">
            <v-icon dark left>save</v-icon>
            {{ $t("lang.common.save") }}
          </v-btn>
          <v-btn color="error" @click="openCreateDialog">
            <v-icon dark left>save</v-icon>
            {{ $t("lang.common.changePass") }}
          </v-btn>

          <school-create-form
              :propsItem="category"
              :cDialog="visibleCreateDialog"
              @closeCreateDialog="closeCreateDialog"
              :formCreateName="formCreateName"/>
        </div>
      </v-flex>

    </v-layout>

  </div>


</template>

<script>
import {message} from "../../../services";
import axios from "axios";
import {areaContants} from "@/constants";
import moment from "moment/moment";
import SchoolCreateForm from "@/views/admin/school_account/SchoolAccountChangePass";
export default {
  name: "school-form-account",
  components: {SchoolCreateForm, message, axios},
  props: {
    propsItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    category: null,
    cDialog: {
      type: Boolean,
      default: false,
    },
    formCreateName: {
      type: String,
      default: '',
    },


  },
  data: () => {
    return {
      showPassword: false,
      areaStatus: areaContants.areaStatus,
      item: {
        userName: "",
        password: "",
      },
      inDialog: false,
    };
  },
  watch: {
    propsItem: {
      handler(value) {
        if (value !== null) {
          this.item =  Object.assign({}, value);
        } else {
          this.resetFrom();
        }
      },
      deep: true,
    },
    cDialog(value) {
      this.inDialog = value;
    },
  },
  methods: {
    resetFrom: function () {
      this.item = Object.assign({}, {"isActive": 1});
    },
    onCancel: function () {
      this.$emit("closeCreateDialog", "");
    },

    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },
    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Đổi mật khẩu';
      } else {
        this.category = item;
        this.formCreateName = 'Đổi mật khẩu';
      }
      this.visibleCreateDialog = true;
    },
    onSave: function () {
      this.$validator.validate().then((valid) => {
        if (!valid) {
          message.error(this.$t("lang.common.validate_fail"));
          return;
        }
        axios
            .post(
                process.env.VUE_APP_API_URL +
                "/schoolAccount/save",
                this.item
            )
            .then(
                (data) => {
                  if (data.success) {
                    message.success(
                        this.$t("lang.common.save_success")
                    );
                  } else {
                    let msg = data.description;
                    message.error(this.$t(msg));
                  }
                },
                (error) => {
                  console.log(error);
                }
            );
      });
    },

  },
  created() {
    axios.post(
        process.env.VUE_APP_API_URL + "/schoolAccount/getInfo",
    )
        .then(
            (data) => {
              this.item = data
            }
        );
  },
};
</script>
